import { createReducer, on } from '@ngrx/store';
import * as RetryProductionInstanceActions from '../actions/retry-production-instance.actions';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';

export const retryProductionInstanceFeatureKey = 'retryProductionInstance';

export interface State {
  record: ProductionInstance | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(RetryProductionInstanceActions.retryProductionInstance, (state) => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(RetryProductionInstanceActions.retryProductionInstanceSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(RetryProductionInstanceActions.retryProductionInstanceFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(RetryProductionInstanceActions.clearRetryProductionInstanceState, () => initialState),
);
